import React, { useState } from 'react';
import styles from './DisableUserModal.module.scss';
import { Button, Icon, Modal, Text } from 'components';
import { usersActions } from 'store/users/slice';
import { useDispatch } from 'store/utils';
import { UserStatus } from 'types';

type Props = {
  onClose(): void;
  userId: string;
};

export const DisableUserModal = ({ onClose, userId }: Props) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const onDisableHandler = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      await dispatch(
        usersActions.updateUser({
          userID: userId,
          userData: {
            status: UserStatus.DISABLED,
          },
        }),
      );
      onClose();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title="Edit user" onClose={onClose}>
      <div className={styles.content}>
        <Icon name="Tick" className={styles.icon} />
        <Text type="body-big">Are you sure you want to disable this user?</Text>
        <Text type="body2" className={styles.info}>
          Access for Urban Smile will be removed, but its data will be kept in the system
        </Text>
      </div>
      <div className={styles.buttonRow}>
        <Button isLink onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onDisableHandler}>Disable</Button>
      </div>
    </Modal>
  );
};
